var _defs, _circle, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThrusters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thrustersPlusPanel",
    "data-name": "ThrustersPlusPanel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Thrusters-cls-1{fill:#14163d;}.Thrusters-cls-2{fill:#94effd;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Thrusters-cls-1",
    cx: 35,
    cy: 35,
    r: 35
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "27 25 35 18 43 25 35 7 27 25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "43 45 35 52 27 45 35 63 43 45"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "25 43 18 35 25 27 7 35 25 43"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "44 27 51 35 44 43 62 35 44 27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrusters);
export default __webpack_public_path__ + "static/media/Thrusters.f383da5d8001166a7dc622dbdaa37290.svg";
export { ForwardRef as ReactComponent };